export default __webpack_public_path__ + "static/media/mobile-banner.58af32d7.jpg";